/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedProfileRouteImport } from './routes/_authed/profile'
import { Route as AuthedAnalyticsIndexRouteImport } from './routes/_authed/analytics/index'
import { Route as AuthedGiftsIndexRouteImport } from './routes/_authed/gifts/index'
import { Route as AuthedGiftsGiftIdRouteImport } from './routes/_authed/gifts/$giftId'
import { Route as AuthedGiftsNewRouteImport } from './routes/_authed/gifts/new'
import { Route as AuthedInvoicesIndexRouteImport } from './routes/_authed/invoices/index'
import { Route as AuthedInvoicesInvoiceIdRouteImport } from './routes/_authed/invoices/$invoiceId'
import { Route as AuthedInvoicesNewRouteImport } from './routes/_authed/invoices/new'
import { Route as AuthedPatientsIndexRouteImport } from './routes/_authed/patients/index'
import { Route as AuthedPatientsPatientIdRouteImport } from './routes/_authed/patients/$patientId'
import { Route as AuthedPatientsNewRouteImport } from './routes/_authed/patients/new'
import { Route as AuthedPricingIndexRouteImport } from './routes/_authed/pricing/index'
import { Route as AuthedScheduleIndexRouteImport } from './routes/_authed/schedule/index'
import { Route as AuthedScheduleNewRouteImport } from './routes/_authed/schedule/new'
import { Route as AuthedSettingsNotificationsRouteImport } from './routes/_authed/settings/notifications'
import { Route as AuthedTasksIndexRouteImport } from './routes/_authed/tasks/index'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAnalyticsIndexRoute = AuthedAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGiftsIndexRoute = AuthedGiftsIndexRouteImport.update({
  id: '/gifts/',
  path: '/gifts/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGiftsGiftIdRoute = AuthedGiftsGiftIdRouteImport.update({
  id: '/gifts/$giftId',
  path: '/gifts/$giftId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGiftsNewRoute = AuthedGiftsNewRouteImport.update({
  id: '/gifts/new',
  path: '/gifts/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInvoicesIndexRoute = AuthedInvoicesIndexRouteImport.update({
  id: '/invoices/',
  path: '/invoices/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInvoicesInvoiceIdRoute = AuthedInvoicesInvoiceIdRouteImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInvoicesNewRoute = AuthedInvoicesNewRouteImport.update({
  id: '/invoices/new',
  path: '/invoices/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPatientsIndexRoute = AuthedPatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPatientsPatientIdRoute = AuthedPatientsPatientIdRouteImport.update({
  id: '/patients/$patientId',
  path: '/patients/$patientId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPatientsNewRoute = AuthedPatientsNewRouteImport.update({
  id: '/patients/new',
  path: '/patients/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPricingIndexRoute = AuthedPricingIndexRouteImport.update({
  id: '/pricing/',
  path: '/pricing/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedScheduleIndexRoute = AuthedScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedScheduleNewRoute = AuthedScheduleNewRouteImport.update({
  id: '/schedule/new',
  path: '/schedule/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsNotificationsRoute =
  AuthedSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTasksIndexRoute = AuthedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/profile': typeof AuthedProfileRoute
  '/gifts/$giftId': typeof AuthedGiftsGiftIdRoute
  '/gifts/new': typeof AuthedGiftsNewRoute
  '/invoices/$invoiceId': typeof AuthedInvoicesInvoiceIdRoute
  '/invoices/new': typeof AuthedInvoicesNewRoute
  '/patients/$patientId': typeof AuthedPatientsPatientIdRoute
  '/patients/new': typeof AuthedPatientsNewRoute
  '/schedule/new': typeof AuthedScheduleNewRoute
  '/settings/notifications': typeof AuthedSettingsNotificationsRoute
  '/analytics/': typeof AuthedAnalyticsIndexRoute
  '/gifts/': typeof AuthedGiftsIndexRoute
  '/invoices/': typeof AuthedInvoicesIndexRoute
  '/patients/': typeof AuthedPatientsIndexRoute
  '/pricing/': typeof AuthedPricingIndexRoute
  '/schedule/': typeof AuthedScheduleIndexRoute
  '/tasks/': typeof AuthedTasksIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/profile': typeof AuthedProfileRoute
  '/': typeof AuthedIndexRoute
  '/gifts/$giftId': typeof AuthedGiftsGiftIdRoute
  '/gifts/new': typeof AuthedGiftsNewRoute
  '/invoices/$invoiceId': typeof AuthedInvoicesInvoiceIdRoute
  '/invoices/new': typeof AuthedInvoicesNewRoute
  '/patients/$patientId': typeof AuthedPatientsPatientIdRoute
  '/patients/new': typeof AuthedPatientsNewRoute
  '/schedule/new': typeof AuthedScheduleNewRoute
  '/settings/notifications': typeof AuthedSettingsNotificationsRoute
  '/analytics': typeof AuthedAnalyticsIndexRoute
  '/gifts': typeof AuthedGiftsIndexRoute
  '/invoices': typeof AuthedInvoicesIndexRoute
  '/patients': typeof AuthedPatientsIndexRoute
  '/pricing': typeof AuthedPricingIndexRoute
  '/schedule': typeof AuthedScheduleIndexRoute
  '/tasks': typeof AuthedTasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/no-access': typeof NoAccessRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/gifts/$giftId': typeof AuthedGiftsGiftIdRoute
  '/_authed/gifts/new': typeof AuthedGiftsNewRoute
  '/_authed/invoices/$invoiceId': typeof AuthedInvoicesInvoiceIdRoute
  '/_authed/invoices/new': typeof AuthedInvoicesNewRoute
  '/_authed/patients/$patientId': typeof AuthedPatientsPatientIdRoute
  '/_authed/patients/new': typeof AuthedPatientsNewRoute
  '/_authed/schedule/new': typeof AuthedScheduleNewRoute
  '/_authed/settings/notifications': typeof AuthedSettingsNotificationsRoute
  '/_authed/analytics/': typeof AuthedAnalyticsIndexRoute
  '/_authed/gifts/': typeof AuthedGiftsIndexRoute
  '/_authed/invoices/': typeof AuthedInvoicesIndexRoute
  '/_authed/patients/': typeof AuthedPatientsIndexRoute
  '/_authed/pricing/': typeof AuthedPricingIndexRoute
  '/_authed/schedule/': typeof AuthedScheduleIndexRoute
  '/_authed/tasks/': typeof AuthedTasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/no-access'
    | '/profile'
    | '/gifts/$giftId'
    | '/gifts/new'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/patients/$patientId'
    | '/patients/new'
    | '/schedule/new'
    | '/settings/notifications'
    | '/analytics/'
    | '/gifts/'
    | '/invoices/'
    | '/patients/'
    | '/pricing/'
    | '/schedule/'
    | '/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/no-access'
    | '/profile'
    | '/'
    | '/gifts/$giftId'
    | '/gifts/new'
    | '/invoices/$invoiceId'
    | '/invoices/new'
    | '/patients/$patientId'
    | '/patients/new'
    | '/schedule/new'
    | '/settings/notifications'
    | '/analytics'
    | '/gifts'
    | '/invoices'
    | '/patients'
    | '/pricing'
    | '/schedule'
    | '/tasks'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/no-access'
    | '/_authed/profile'
    | '/_authed/'
    | '/_authed/gifts/$giftId'
    | '/_authed/gifts/new'
    | '/_authed/invoices/$invoiceId'
    | '/_authed/invoices/new'
    | '/_authed/patients/$patientId'
    | '/_authed/patients/new'
    | '/_authed/schedule/new'
    | '/_authed/settings/notifications'
    | '/_authed/analytics/'
    | '/_authed/gifts/'
    | '/_authed/invoices/'
    | '/_authed/patients/'
    | '/_authed/pricing/'
    | '/_authed/schedule/'
    | '/_authed/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  NoAccessRoute: typeof NoAccessRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/analytics/': {
      id: '/_authed/analytics/'
      path: '/analytics'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthedAnalyticsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gifts/': {
      id: '/_authed/gifts/'
      path: '/gifts'
      fullPath: '/gifts/'
      preLoaderRoute: typeof AuthedGiftsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gifts/$giftId': {
      id: '/_authed/gifts/$giftId'
      path: '/gifts/$giftId'
      fullPath: '/gifts/$giftId'
      preLoaderRoute: typeof AuthedGiftsGiftIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/gifts/new': {
      id: '/_authed/gifts/new'
      path: '/gifts/new'
      fullPath: '/gifts/new'
      preLoaderRoute: typeof AuthedGiftsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invoices/': {
      id: '/_authed/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthedInvoicesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invoices/$invoiceId': {
      id: '/_authed/invoices/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AuthedInvoicesInvoiceIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invoices/new': {
      id: '/_authed/invoices/new'
      path: '/invoices/new'
      fullPath: '/invoices/new'
      preLoaderRoute: typeof AuthedInvoicesNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/patients/': {
      id: '/_authed/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof AuthedPatientsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/patients/$patientId': {
      id: '/_authed/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthedPatientsPatientIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/patients/new': {
      id: '/_authed/patients/new'
      path: '/patients/new'
      fullPath: '/patients/new'
      preLoaderRoute: typeof AuthedPatientsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/pricing/': {
      id: '/_authed/pricing/'
      path: '/pricing'
      fullPath: '/pricing/'
      preLoaderRoute: typeof AuthedPricingIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schedule/': {
      id: '/_authed/schedule/'
      path: '/schedule'
      fullPath: '/schedule/'
      preLoaderRoute: typeof AuthedScheduleIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/schedule/new': {
      id: '/_authed/schedule/new'
      path: '/schedule/new'
      fullPath: '/schedule/new'
      preLoaderRoute: typeof AuthedScheduleNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings/notifications': {
      id: '/_authed/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthedSettingsNotificationsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tasks/': {
      id: '/_authed/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthedTasksIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedGiftsGiftIdRoute: typeof AuthedGiftsGiftIdRoute
  AuthedGiftsNewRoute: typeof AuthedGiftsNewRoute
  AuthedInvoicesInvoiceIdRoute: typeof AuthedInvoicesInvoiceIdRoute
  AuthedInvoicesNewRoute: typeof AuthedInvoicesNewRoute
  AuthedPatientsPatientIdRoute: typeof AuthedPatientsPatientIdRoute
  AuthedPatientsNewRoute: typeof AuthedPatientsNewRoute
  AuthedScheduleNewRoute: typeof AuthedScheduleNewRoute
  AuthedSettingsNotificationsRoute: typeof AuthedSettingsNotificationsRoute
  AuthedAnalyticsIndexRoute: typeof AuthedAnalyticsIndexRoute
  AuthedGiftsIndexRoute: typeof AuthedGiftsIndexRoute
  AuthedInvoicesIndexRoute: typeof AuthedInvoicesIndexRoute
  AuthedPatientsIndexRoute: typeof AuthedPatientsIndexRoute
  AuthedPricingIndexRoute: typeof AuthedPricingIndexRoute
  AuthedScheduleIndexRoute: typeof AuthedScheduleIndexRoute
  AuthedTasksIndexRoute: typeof AuthedTasksIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedGiftsGiftIdRoute: AuthedGiftsGiftIdRoute,
  AuthedGiftsNewRoute: AuthedGiftsNewRoute,
  AuthedInvoicesInvoiceIdRoute: AuthedInvoicesInvoiceIdRoute,
  AuthedInvoicesNewRoute: AuthedInvoicesNewRoute,
  AuthedPatientsPatientIdRoute: AuthedPatientsPatientIdRoute,
  AuthedPatientsNewRoute: AuthedPatientsNewRoute,
  AuthedScheduleNewRoute: AuthedScheduleNewRoute,
  AuthedSettingsNotificationsRoute: AuthedSettingsNotificationsRoute,
  AuthedAnalyticsIndexRoute: AuthedAnalyticsIndexRoute,
  AuthedGiftsIndexRoute: AuthedGiftsIndexRoute,
  AuthedInvoicesIndexRoute: AuthedInvoicesIndexRoute,
  AuthedPatientsIndexRoute: AuthedPatientsIndexRoute,
  AuthedPricingIndexRoute: AuthedPricingIndexRoute,
  AuthedScheduleIndexRoute: AuthedScheduleIndexRoute,
  AuthedTasksIndexRoute: AuthedTasksIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  NoAccessRoute: NoAccessRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
